// Pure photo-consent constants. Safe for client and server: no imports, no server code.
export const PHOTO_CONSENT_VERSION = '2026-10-29.1';
export const ACCEPTED_PHOTO_CONSENT_VERSIONS: readonly string[] = [PHOTO_CONSENT_VERSION];
export const PHOTO_CONSENT_FIELD = 'photoConsent';

export function consentBody(version: string): { photoConsent: { version: string } } {
  return { photoConsent: { version } };
}
